module.exports = __webpack_public_path__ + "img/carousel-next--orange.f32b7fa4.svg";